<template class="full-height">
  <div class="coupon-category-app-container" style="position: relative; height: 100%">
    <el-dialog
      :top="dialogTopMargin"
      :title="`[${travelName}] - 分房表`"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <el-card v-loading="dialogLoading">
        <div class="tag-container">
          <div
            v-for="(tab, index) in travelerRooms"
            :key="`${index}_${tab.day}`"
            @click="activeTab = index"
            class="tag-item"
            :class="{ 'tag-item--active': activeTab == index }"
          >
            第{{ tab.day }}天
          </div>
        </div>
        <p class="hotel-title">
          <i class="el-icon-s-home"></i>
          住宿旅館：{{
            travelerRooms[activeTab] && travelerRooms[activeTab].hotelName
              ? travelerRooms[activeTab].hotelName
              : '未設定'
          }}
        </p>
        <div v-if="travelerRooms[activeTab] && travelerRooms[activeTab].travelersRoomList">
          <el-table
            :header-cell-style="{ background: '#eee', color: '#000' }"
            size="mini"
            border
            :span-method="handleSpanMethod"
            :data="travelerRooms[activeTab].travelersRoomList"
            max-height="50vh"
            style="overflow: auto"
          >
            <el-table-column align="center" label="項次" width="60">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column property="travelersGroup" label="分組" width="120" />
            <!-- <el-table-column property="travelersRoomName" label="房號" width="120">
              <template slot-scope="{ row }">
                <div class="room-container">
                  <div class="room-tag" v-if="!!row.travelersRoomName"
                    v-for="tag in  row.travelersRoomName.includes(',') ? row.travelersRoomName.split(',') : [row.travelersRoomName]">
                    {{ tag }}
                  </div>
                </div>
              </template>
            </el-table-column> -->
            <el-table-column property="travelersRoomName" label="房號" width="200">
              <template slot-scope="scope">
                <el-input v-if="editRowStatus === 1" v-model="scope.row.travelersRoomName">
                </el-input>
                <p v-else>{{ scope.row.travelersRoomName }}</p>
              </template>
            </el-table-column>
            <el-table-column property="travelersIdentity" label="身份" width="150" />
            <el-table-column property="travelersName" label="旅客姓名" width="150" />
            <el-table-column property="mobile" label="電話號碼" width="100" />
            <el-table-column property="agencyRemind" label="旅行社提醒" />
            <el-table-column property="leaderRemind" label="領隊備註" />
          </el-table>
        </div>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <div v-if="editRowStatus === 1">
          <el-button type="warning" style="color: #4b4b4b" @click="handleSetTravelersRoomHistory"
            >儲 存</el-button
          >
          <el-button @click="dialogVisible = false">取 消</el-button>
        </div>
        <el-button v-else type="danger" @click="dialogVisible = false">關 閉</el-button>
      </div>
    </el-dialog>

    <el-form :inline="true" class="filter-form" @submit.native.prevent>
      <el-form-item label="查詢">
        <el-input
          v-model="listQuery.qry"
          @keyup.enter.native="getList"
          placeholder="輸入團號/團名"
        />
      </el-form-item>

      <el-button
        type="primary"
        @click="getList"
        icon="el-icon-search"
        circle
        style="margin-top: 8px; margin-left: 5px"
        :disabled="listLoading"
      ></el-button>
      <el-button
        style="cursor: pointer"
        type="success"
        :loading="listLoading"
        circle
        icon="el-icon-refresh-left"
        @click="refresh()"
      ></el-button>
    </el-form>

    <div style="position: relative; height: 80%">
      <el-table
        ref="formDetailsTable"
        v-loading="listLoading || dialogLoading"
        size="mini"
        :data="list"
        border
        style="width: 100%"
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="tourGroupNo" label="團號" width="200" align="center">
        </el-table-column>

        <el-table-column align="center" label="團名" width="450">
          <template slot-scope="{ row }">
            <span>{{ row.travelName }}</span>
            <div>
              <el-tag style="font-size: 14px">
                出發
                <span style="color: red">{{ `${row.beginDate} ${row.beginTime}` }}</span>
                - 回程
                <span style="color: red">{{ `${row.endDate} ${row.endTime}` }}</span>
              </el-tag>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="狀態" width="130">
          <template slot-scope="scope">
            <el-tag :type="statusTranslateStyle(scope.row.status)">{{
              scope.row.statusDesc
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="查看分房表" width="130">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleGetTravelersRoomHistory(scope.row)"
              >查看分房表</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { getGroupTourList, getTravelersRoomHistory, setTravelersRoomHistory } from '@/api/travel'

export default {
  name: 'AgencyTravelersRoomHistories',
  components: {
    Pagination,
  },
  data() {
    return {
      activeTab: 0,
      editRowStatus: 0,
      travelID: '',
      travelName: '',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        dates: null,
        travelProperty: null,
        memberCount: 0,
        countryArea: [],
        dateFilter: [],
        memberQry: '',
        qry: '',
        qrySecond: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-beginDate',
        agencyCode: null,
      },
      total: 0,
      list: [],
      travelerRooms: [],
    }
  },
  async created() {
    const agencyCode = this.$store.getters.userInfo.agencyCode
    this.listQuery.agencyCode = agencyCode
    await this.getList()
  },
  methods: {
    handleSpanMethod({ row, column, rowIndex, columnIndex }) {
      const travelersRoomList = this.travelerRooms[this.activeTab].travelersRoomList
      if (columnIndex === 0) {
        let rowspan = 1
        for (let i = rowIndex + 1; i < travelersRoomList.length; i++) {
          if (travelersRoomList[i].travelersName === row.travelersName) {
            rowspan++
          } else {
            break
          }
        }
        return [rowspan, 1]
      } else if (columnIndex === 1) {
        if (rowIndex > 0 && row.travelersGroup === travelersRoomList[rowIndex - 1].travelersGroup) {
          return [0, 0] // 如果和上一行的相同，不顯示
        } else {
          let rowspan = 1
          for (let i = rowIndex + 1; i < travelersRoomList.length; i++) {
            if (travelersRoomList[i].travelersGroup === row.travelersGroup) {
              rowspan++
            } else {
              break
            }
          }
          return [rowspan, 1]
        }
      } else if (columnIndex === 2) {
        if (rowIndex > 0 && row.travelersGroup === travelersRoomList[rowIndex - 1].travelersGroup) {
          return [0, 0] // 如果和上一行的相同，不顯示
        } else {
          let rowspan = 1
          for (let i = rowIndex + 1; i < travelersRoomList.length; i++) {
            if (travelersRoomList[i].travelersGroup === row.travelersGroup) {
              rowspan++
            } else {
              break
            }
          }
          return [rowspan, 1]
        }
      }
    },
    async refresh() {
      this.listQuery = {
        dates: null,
        travelProperty: null,
        memberCount: 0,
        countryArea: [],
        dateFilter: [],
        memberQry: '',
        qry: '',
        qrySecond: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-beginDate',
        agencyCode: this.$store.getters.userInfo.agencyCode,
      }
      await this.getList()
    },

    async getList() {
      this.listLoading = true
      let resp = await getGroupTourList(this.listQuery)
      this.list = resp.data.data
      this.total = resp.data.total
      this.listLoading = false
    },

    // 取得旅客分房表
    async handleGetTravelersRoomHistory(travel) {
      this.activeTab = 0
      this.editRowStatus = travel.status
      this.travelID = travel.id
      this.travelName = travel.travelName
      this.dialogLoading = true
      await getTravelersRoomHistory(travel.id)
        .then(res => {
          this.dialogVisible = true
          this.travelerRooms = res.data
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.dialogLoading = false
        })
    },

    // 設定旅客分房表
    async handleSetTravelersRoomHistory() {
      this.travelerRooms.forEach(day => {
        const groupMap = {}
        day.travelersRoomList.forEach(room => {
          const group = room.travelersGroup

          if (groupMap[group] === undefined) {
            groupMap[group] = room.travelersRoomName
          }

          room.travelersRoomName = groupMap[group]
        })
      })

      const params = {
        travelID: this.travelID,
        travelersRoomHistoryList: this.travelerRooms,
      }
      this.dialogLoading = true
      await setTravelersRoomHistory(params)
        .then(res => {
          this.$message({
            message: '操作成功',
            type: 'success',
          })
          this.dialogVisible = false
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.dialogLoading = false
        })
    },

    statusTranslateStyle(status) {
      let r = ''
      switch (status) {
        case 0:
          r = 'info'
          break
        case 1:
          r = 'success'
          break
        case 2:
          r = 'warning'
          break
        case 3:
        case 4:
          r = 'danger'
          break
        default:
          break
      }
      return r
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}

.el-table .success-row {
  background: #f0f9eb;
}

.el-table__expanded-cell,
.el-table__expanded-cell:hover {
  background-color: cornsilk !important;
}

.el-tabs--card {
  height: calc(100vh - 200px);
  /* overflow-y: auto; */
}

.el-tab-pane {
  height: calc(100vh - 200px);
  /* overflow-y: auto; */
}

.el-table__expand-icon {
  display: none;
}

.tag-container {
  max-width: 100%;
  overflow-x: auto;
  display: flex;
  gap: 0.75rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.tag-item {
  cursor: pointer;
  min-width: fit-content;
  border-radius: 0.5rem;
  padding: 6px 12px;
  color: #000;
  background: #ffffff;
  letter-spacing: 0.2em;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
}

.tag-item:hover {
  opacity: 0.9;
}

.tag-item--active {
  background: #fed465;
  font-weight: 500;
}

.room-container {
  display: flex;
  flex-direction: column;
  row-gap: 3px;
}

.room-tag {
  background-color: #fed465;
  border-color: #fed465;
  color: #000;
  border-radius: 8px;
  padding: 2px 0;
  text-align: center;
}

.hotel-title {
  background-color: #ffe483;
  display: inline-block;
  padding: 0.375rem 0.5rem;
  border-radius: 0.25rem;
  color: #000;
  letter-spacing: 0.05em;
}
</style>
